/**
 * @param {*} value cell value
 * @param {*} filterValue selected option or search string
 * @param {string} emptyLabel label for null/empty values in multi-select
 * @param {{ exact?: boolean }} [options] exact=true for multi-select (avoid "21_век" matching "21_век_Склад")
 */
export const matchEmptyOrIncludes = (value, filterValue, emptyLabel, options = {}) => {
    if (filterValue === emptyLabel) {
        return value == null || value === ''
    }
    if (value == null) {
        return false
    }
    const cell = value.toString().toLowerCase()
    const filter = String(filterValue).toLowerCase()
    return options.exact ? cell === filter : cell.includes(filter)
}
